import React from 'react'
import { Text } from '@/components/atoms/Text'
import './NavItem.css'

export interface NavItemProps {
  label: string
  href?: string
  onClick?: () => void
  active?: boolean
  className?: string
}

export const NavItem: React.FC<NavItemProps> = ({
  label,
  href = '#',
  onClick,
  active = false,
  className = '',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault()
      onClick()
    }
  }

  const itemClasses = [
    'nav-item',
    active ? 'nav-item-active' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <a
      href={href}
      onClick={handleClick}
      className={itemClasses}
    >
      <Text 
        size="small" 
        color="primary" 
        weight="medium"
      >
        {label}
      </Text>
    </a>
  )
}
